import { render, staticRenderFns } from "./ptDetail.vue?vue&type=template&id=7d234bcb&scoped=true&"
import script from "./ptDetail.vue?vue&type=script&lang=js&"
export * from "./ptDetail.vue?vue&type=script&lang=js&"
import style0 from "./ptDetail.vue?vue&type=style&index=0&id=7d234bcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d234bcb",
  null
  
)

export default component.exports